import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { MenuComponent } from './menu/menu.component';
import { FooterComponent } from './footer/footer.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { MenuMobileComponent } from './menu-mobile/menu-mobile.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    HeaderComponent,
    MenuComponent,
    FooterComponent,
    MenuMobileComponent,
  ],
  imports: [
    CommonModule,
    NgbModule,
    RouterModule,
		FormsModule
  ],
  exports: [
    HeaderComponent,
    MenuComponent,
    MenuMobileComponent,
    FooterComponent,
  ]
})
export class CoreComponentsModule { }
